import { gql } from "@apollo/client";

export const ANNIVERSARY_GIFT_TEASER = gql`
  query getAnniversaryGiftModal {
    getAnniversaryGiftModal {
      modalHeader
      modalDescription
      termsAndConditions
      gifts {
        id
        image
        label
        slug
      }
    }
  }
`;
